// Язык страницы, на которой стоит виджет: <html lang> сайта клиента. Сервер
// берёт его вторым сигналом после языка разговора и раньше языка браузера
// (Widget::BaseController#guest_locale): русский магазин с английским
// браузером гостя показывал «Usually replies within a couple of minutes» и
// «Check out» (mkel.ru, 05.09.2026).

/** Двухбуквенный код языка страницы или пустая строка, если сайт его не объявил. */
export function pageLanguage(doc: { documentElement?: { lang?: string } | null } | null | undefined): string {
  const raw = doc?.documentElement?.lang ?? '';
  const code = raw
    .trim()
    .toLowerCase()
    .match(/^[a-z]{2}/);
  return code ? code[0] : '';
}
